import { Card, Spinner } from '../../components';
import { MAX_CARD_WIDTH } from '../../constants';
import { useGetOrganizationSettingsQuery } from '../../services';
import { ComponentSize } from '../../types';
import Access from './Access';
import Benchmarks from './Benchmarks';
import CustomVocabulary from './CustomVocabulary';
import DefaultAIScorecard from './DefaultAIScorecard';

const Organization = () => {
  const { data: orgConfigs, isLoading: isLoadingOrgSettings } = useGetOrganizationSettingsQuery({});
  const {
    vocabulary,
    repCanScoreSimCalls,
    repCanScoreRealCalls,
    repCanCreateSims,
    repCanViewLibrary,
    repCanEditLibrary,
    defaultScorecardTemplateId,
  } = orgConfigs || {};

  if (isLoadingOrgSettings) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner size={ComponentSize.MEDIUM} />
      </div>
    );
  }

  return (
    <Card maxWidth={MAX_CARD_WIDTH} className="mx-auto">
      <DefaultAIScorecard defaultScorecardTemplateId={defaultScorecardTemplateId ?? undefined} />
      {!!orgConfigs && <Benchmarks orgConfigs={orgConfigs} />}
      <CustomVocabulary vocabulary={vocabulary ?? []} />
      <Access
        repCanScoreSimCalls={repCanScoreSimCalls ?? false}
        repCanScoreRealCalls={repCanScoreRealCalls ?? false}
        repCanCreateSims={repCanCreateSims ?? false}
        repCanViewLibrary={repCanViewLibrary ?? false}
        repCanEditLibrary={repCanEditLibrary ?? false}
      />
    </Card>
  );
};

export default Organization;
